// EditConsolidadoModal.jsx

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import axios from 'axios';

// Soft UI
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import SoftInput from 'components/SoftInput';

// SweetAlert2
import Swal from 'sweetalert2';

function EditConsolidadoModal({
  show,
  onClose,
  masterNumber,
  initialAgent,
  initialTransportista,
  initialOrigen,
  initialDestino,
  onUpdated,
}) {
  const [agent, setAgent] = useState('');
  const [transportista, setTransportista] = useState('');
  const [origen, setOrigen] = useState('');
  const [destino, setDestino] = useState('');

  // Al montar o cuando cambien los props, llenamos los estados
  useEffect(() => {
    if (show) {
      setAgent(initialAgent || '');
      setTransportista(initialTransportista || '');
      setOrigen(initialOrigen || '');
      setDestino(initialDestino || '');
    }
  }, [show, initialAgent, initialTransportista, initialOrigen, initialDestino]);

  const showToast = (icon, title) => {
    Swal.fire({
      icon,
      title,
      toast: true,
      position: 'top-end',
      timer: 3000,
      showConfirmButton: false,
    });
  };

  const handleSave = () => {
    // Validaciones
    if (!agent.trim()) {
      showToast('warning', 'Debe ingresar un agente');
      return;
    }
    if (!transportista.trim()) {
      showToast('warning', 'Debe ingresar un medio de transporte');
      return;
    }
    if (!origen.trim()) {
      showToast('warning', 'Debe ingresar un origen');
      return;
    }
    if (!destino.trim()) {
      showToast('warning', 'Debe ingresar un destino');
      return;
    }

    // Enviar al endpoint
    axios.patch(`${process.env.REACT_APP_SERVER_URL}/api/finance/consolidated/`, {
      mas: masterNumber,
      age: agent,
      tra: transportista,
      ori: origen,
      des: destino,
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        showToast('success', response.data.message);
        onUpdated();
        onClose();
      })
      .catch((error) => {
        console.error('Error al actualizar el consolidado:', error);
        showToast('error', 'No se pudo actualizar el consolidado, intente nuevamente.');
      });
  };

  return (
    <Modal show={show} onHide={onClose} size="md" centered backdrop="static">
      <Modal.Header closeButton>
        <SoftTypography variant="h5" fontWeight="bold">
          Editar Consolidado
        </SoftTypography>
      </Modal.Header>
      <Modal.Body>
        <SoftBox display="flex" flexDirection="column" gap={2}>
          <SoftTypography variant="caption">Agente</SoftTypography>
          <SoftInput
            type="text"
            value={agent}
            onChange={(e) => setAgent(e.target.value)}
            placeholder="Ingrese agente"
          />

          <SoftTypography variant="caption">Transportista</SoftTypography>
          <SoftInput
            type="text"
            value={transportista}
            onChange={(e) => setTransportista(e.target.value)}
            placeholder="Ingrese transportista"
          />

          <SoftTypography variant="caption">Origen</SoftTypography>
          <SoftInput
            type="text"
            value={origen}
            onChange={(e) => setOrigen(e.target.value)}
            placeholder="Ingrese origen"
          />

          <SoftTypography variant="caption">Destino</SoftTypography>
          <SoftInput
            type="text"
            value={destino}
            onChange={(e) => setDestino(e.target.value)}
            placeholder="Ingrese destino"
          />
        </SoftBox>
      </Modal.Body>
      <Modal.Footer>
        <SoftButton color="success" variant="gradient" onClick={handleSave}>
          Guardar
        </SoftButton>
      </Modal.Footer>
    </Modal>
  );
}

EditConsolidadoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  masterNumber: PropTypes.string.isRequired,
  initialAgent: PropTypes.string,
  initialTransportista: PropTypes.string,
  initialOrigen: PropTypes.string,
  initialDestino: PropTypes.string,
  onUpdated: PropTypes.func.isRequired,
};

EditConsolidadoModal.defaultProps = {
  initialAgent: '',
  initialTransportista: '',
  initialOrigen: '',
  initialDestino: '',
};

export default EditConsolidadoModal;
